import { useGoogleLogin } from "@react-oauth/google";

/**
 * Google's implicit flow, read the way Getting in needs it: a token, or a
 * failure worth saying. A closed or blocked popup does nothing and says
 * nothing (journey 4).
 */
export function useGoogleToken({
  onToken,
  onFailure,
}: {
  onToken: (accessToken: string) => void;
  onFailure?: () => void;
}) {
  return useGoogleLogin({
    flow: "implicit",
    onSuccess: (response) => onToken(response.access_token),
    onError: () => onFailure?.(),
    onNonOAuthError: (error) => {
      if (error.type === "popup_closed") return;
      onFailure?.();
    },
  });
}

/** The address behind a Google token, straight from Google (shown before joining). */
export async function googleAddress(accessToken: string): Promise<string | null> {
  try {
    const res = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!res.ok) return null;
    const body = (await res.json()) as { email?: string };
    return body.email ?? null;
  } catch {
    return null;
  }
}
